<!--
  -  Copyright (c) Qwoach LLC 2021. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 13/12/2021
  -->

<template>
	<div class="line-type-item-view-root" :class="{'mb-4': addBottomMargin}">

		<div class="mb-2 card p-2" @click="onItemClicked" :class="{'line-type-selected': lineTypeItem.isSelected && !isViewOnly, 'pointer': !isViewOnly, 'hover': !isViewOnly}">
			<div v-if="showTitleInline">
				<div class="mb-2">
					<img :src="previewSrcComputed" :alt="lineTypeItem.title" width="120" :height="lineHeightComputed" style="width: 100%; object-fit: contain;"/> <!--width and height are needed for SEO-->
				</div>
				<div class="text-center bold font-size-3">{{ titlePrefix }} {{ lineTypeItem.title }}</div>
			</div>
			<ToolTipView v-else>
				<template #icon>
					<div>
						<img :src="previewSrcComputed" :alt="lineTypeItem.title" width="120" :height="lineHeightComputed" style="width: 100%; object-fit: contain;"/> <!--width and height are needed for SEO-->
					</div>
				</template>
                <div>{{ titlePrefix }} {{ lineTypeItem.title }}</div>
			</ToolTipView>
		</div>
	</div>

</template>

<script>
import BaseComponent from "@/core/components/BaseComponent.vue";
import {GenogramConnectionCategoryEnum} from "@shared/Genogram/GenogramConnectionCategoryEnum";
import {LineTypeItem} from "@/core/recoveryCoachingApp/coach/clients/ClientDetails/Genogram/GenogramEditor/lib/cyeditor-edit-elements/LineTypeItem";
import ToolTipView from "@/core/components/Form/Base/ToolTipView.vue";

export default {
	name: "LineTypeItemView",
	components: {ToolTipView},
	extends: BaseComponent,

	props: {
		lineTypeItem: {LineTypeItem, required: true},
        titlePrefix: null,
		showTitleInline: {Boolean, default: true},
        isViewOnly: Boolean,
		addBottomMargin: {type: Boolean, default: true},
	},

	watch: {
		lineTypeItem: {
			handler(val) {
				console.log("lineTypeItem watch: ", this.lineTypeItem)
				this.isItemSelected = this.lineTypeItem.isSelected
			},
			deep: true
		}
	},

	data() {
		return {
			isItemSelected: false
		}
	},

	methods: {
		onItemClicked() {
			this.$emit('click', this.lineTypeItem)
			// this.$forceUpdate()
		}
	},

	computed: {
		getLineTypeFullComputed() {
			return this.lineTypeItem.getLineTypeFull()
		},
		previewSrcComputed() {
			if(this.lineTypeItem.previewSrc){
				return this.lineTypeItem.previewSrc
			}
			return require(`../../assets/images/line-${this.getLineTypeFullComputed}.png`)
		},
		lineHeightComputed() {
			//this is a proxy estimation. We need the number for SEO purposes so layout is not jumping,
			//but when saving to image, html-to-image has issues rendering images with object-fit: contain;
			return this.lineTypeItem.connectionCategory === GenogramConnectionCategoryEnum.SOCIAL ? "34" : "21"
		}
	},
}
</script>

<style lang="scss">
.line-type-item-view-root {
	.line-type-selected {
		border: 3px solid #00aff0;
	}

}
</style>
